import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { onNativePlatformPopStackToBottom } from "@app/presentation/utils/navigation";
import { from, switchMap, take } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class RedirectUrlService {
  constructor(private router: Router) {}
  private _redirectUrl: string | null = null;

  /*saveRedirectUrlIfItExistsInUrl() {
    const fullRedirectUrl =
      this.activatedRoute.snapshot.queryParamMap.get("redirectUrl");
    if (!!fullRedirectUrl) {
      const url = new URL(fullRedirectUrl);
      this.redirectUrl = url.pathname;
    } else console.log("no redirect url");
    console.log("this.redirectUrl", this._redirectUrl);
  }*/

  saveRedirectUrl(url: string) {
    this.redirectUrl = url;
  }

  navigateToRedirectUrl() {
    if (!!this.redirectUrl) {
      from(this.router.navigate([this.redirectUrl]))
        .pipe(take(1))
        .subscribe(() => {
          this.removeRedirectUrl();
        });
    }
  }

  existsRedirectUrl() {
    return !!this._redirectUrl;
  }

  getRedirectUrl() {
    return this._redirectUrl;
  }

  private removeRedirectUrl() {
    this._redirectUrl = null;
  }

  private set redirectUrl(url: string | null) {
    this._redirectUrl = url;
  }
  private get redirectUrl() {
    return this._redirectUrl;
  }
}
